/**
 * Select Component
 * Reusable select component with error handling
 */

const Select = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  required = false,
  options = [],
  placeholder,
  className = '',
  ...props
}) => {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={name} className="block text-pitch-green font-bold mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        className={`
          w-full bg-gray-900 border rounded-lg px-4 py-3 text-white
          focus:outline-none transition-colors cursor-pointer
          ${error ? 'border-red-500' : 'border-pitch-green/30 focus:border-pitch-green'}
          ${className}
        `}
        {...props}
      >
        {placeholder && (
          <option value="">{placeholder}</option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  )
}

export default Select
